import { jsx as _jsx } from "react/jsx-runtime";
import { useStyles } from '~/views/molecules/dialog-buttons/styles';
import { IconButton } from '@mui/material';
import { LeftArrow } from '~/views/atoms/svg-icons';
import React from 'react';
export const LeftArrowButton = ({ leftArrowButtonHandler, disabled }) => {
    const classes = useStyles();
    return (_jsx(IconButton, { disabled: disabled, className: classes.leftButton, onClick: leftArrowButtonHandler, children: _jsx(LeftArrow, { color: "primary" }) }));
};
